import { render, staticRenderFns } from "./AtopicDermatitisChildBody.vue?vue&type=template&id=40e32b87&scoped=true&"
import script from "./AtopicDermatitisChildBody.vue?vue&type=script&lang=js&"
export * from "./AtopicDermatitisChildBody.vue?vue&type=script&lang=js&"
import style0 from "./AtopicDermatitisChildBody.vue?vue&type=style&index=0&id=40e32b87&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e32b87",
  null
  
)

export default component.exports